const mixin = {
    data() {
        return {
            addressConfirmed: false,
            showGav: false,
            gavAddress: null,
            inputAddress: null,
            edited: false
        };
    },

    methods: {
        openGavAndLoadSuggestions(address, edited = false) {
            try {
                this.gavAddress = this.inputAddress = address;
                this.edited = edited;
                this.addressConfirmed = false;
                const loadPromise = this.$refs.gav.loadSuggestions(this.gavAddress);
                Promise.all([loadPromise]).then(() => {
                    if (!this.addressConfirmed) {
                        this.showGav = true;
                    }
                });
            } catch(error) {
                console.log("Error validating address: " + JSON.stringify(error));
            }
        },

        handleGavConfirm(address) {
            const modified = this.edited || !this.inputAddress.id || this.addressChanged(address);
            Object.assign(this.inputAddress, address, {verified: true});
            this.addressConfirmed = true;
            this.showGav = false;
            return [modified, this.inputAddress];
        },

        cancelGav() {
            this.inputAddress.verified = true;
            this.showGav = false;
        },

        addressChanged(confirmedAddress) {
            return this.inputAddress.address1 !== confirmedAddress.address1 ||
                this.inputAddress.address2 !== confirmedAddress.address2 ||
                this.inputAddress.address3 !== confirmedAddress.address3 ||
                this.inputAddress.city !== confirmedAddress.city ||
                this.inputAddress.district !== confirmedAddress.district ||
                this.inputAddress.region !== confirmedAddress.region ||
                this.inputAddress.postalCode !== confirmedAddress.postalCode ||
                this.inputAddress.country !== confirmedAddress.country;
        }
    }
}

export default mixin;
